// OG-image-hjälpare för landningssidor.
//
// VIKTIGT: Alla sidor ska dela samma huvud-OG-bild för att LinkedIn/Slack/
// X/FB konsekvent visar samma featured image (uppladdad i Lovable publish
// settings). Hub-parametern behålls för bakåtkompatibilitet men ignoreras
// — `ogImageFor` returnerar alltid `SOCIAL_IMAGE_URL`.

import {
  SOCIAL_IMAGE_URL,
  SOCIAL_IMAGE_ALT,
  SOCIAL_IMAGE_WIDTH,
  SOCIAL_IMAGE_HEIGHT,
} from "./constants";

export type OgHub =
  | "default"
  | "videobyra"
  | "filmbyra"
  | "filmproduktion"
  | "produktionsbolag"
  | "brollopsfilm";

/** Absolut URL för huvud-OG-bilden. Hub ignoreras — alltid samma bild. */
export function ogImageFor(_hub: OgHub = "default"): string {
  return SOCIAL_IMAGE_URL;
}

export interface OgImageMetaInput {
  hub?: OgHub;
  alt?: string;
}

/**
 * Genererar OG/Twitter-image-meta-taggar för `head().meta`.
 * Alla sidor får samma huvudbild — `alt` får överstyras per sida.
 */
export function ogImageMeta({
  alt = SOCIAL_IMAGE_ALT,
}: OgImageMetaInput = {}): Array<{ property?: string; name?: string; content: string }> {
  return [
    { property: "og:image", content: SOCIAL_IMAGE_URL },
    { property: "og:image:width", content: SOCIAL_IMAGE_WIDTH },
    { property: "og:image:height", content: SOCIAL_IMAGE_HEIGHT },
    { property: "og:image:alt", content: alt },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:image", content: SOCIAL_IMAGE_URL },
    { name: "twitter:image:alt", content: alt },
  ];
}
